<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block;  margin-bottom: 10px">
                                    <span style="margin-right: 12px">工程名称</span>
                                    <el-input v-model="tableParam.engineeringName"
                                        style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">责任预算</span>
                                    <el-input v-model="tableParam.budgetPerson"
                                        style="width: 100px; min-width: 100px; max-width: 120px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">状态</span>
                                    <el-select v-model="tableParam.nodeControlStatus" style="width: 150px" clearable>
                                        <el-option label="待风控" :value="0"></el-option>
                                        <el-option label="已风控" :value="1"></el-option>
                                        <el-option label="临时解控" :value="2"></el-option>
                                        <el-option label="完全解控" :value="3"></el-option>
                                    </el-select>
                                </span>
                                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div>
                            </div>
                            <div>
                                <el-link :underline="false" @click="load()">
                                    <span class="el-icon--left">
                                        <i class="iconfont iconicon_button_export1"></i>
                                    </span>
                                    导出
                                </el-link>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :height="screenHeight - 425" :data="tableData"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '状态'">
                                                <el-link v-if="scope.row.nodeControlStatus == 0" type="danger"
                                                    :underline="false"
                                                    @click="getProcessDifferHistory(scope.row)">待风控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 1" type="danger"
                                                    :underline="false"
                                                    @click="getProcessDifferHistory(scope.row)">已风控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 2" type="success"
                                                    :underline="false"
                                                    @click="getProcessDifferHistory(scope.row)">临时解控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 3" type="success"
                                                    :underline="false"
                                                    @click="getProcessDifferHistory(scope.row)">完全解控</el-link>
                                            </span>
                                            <span v-else-if="item.label == '审批/确定状态'">
                                                <span v-if="scope.row.approvalStatus == 0">待确认</span>
                                                <span v-if="scope.row.approvalStatus == 1">已确认</span>
                                                <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                                                <span v-if="scope.row.approvalStatus == 3">审批中</span>
                                                <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                                                <span v-if="scope.row.approvalStatus == 5">撤销</span>
                                            </span>
                                            <span v-else-if="item.label == '操作'">
                                                <el-link v-if="scope.row.nodeControlStatus == 0" type="success"
                                                    :underline="false" @click="confirm(scope.row, 2)">确 认</el-link>
                                                <el-link
                                                    v-if="scope.row.approvalStatus != 1 && scope.row.approvalStatus != 3 && (scope.row.nodeControlStatus == 1 || scope.row.nodeControlStatus == 2)"
                                                    type="danger" :underline="false"
                                                    @click="applyRemoveControl(scope.row)">申请解控</el-link>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
            <!-- 申请解控 -->
            <el-dialog :visible.sync="removeControlDig" width="1140px" :close-on-click-modal="false"   >
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item label="工程名称：" :span="2">{{ formData.engineeringName }}</el-descriptions-item>
                    <el-descriptions-item label="工程ID：">{{ formData.engineeringId }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{ formData.businesName }}</el-descriptions-item>
                    <el-descriptions-item label="施工进度：">{{ formData.constructionProgress }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="签订主体：">{{ formData.collaborationUnitName }}</el-descriptions-item>
                    <el-descriptions-item label="预算员：">{{ formData.budgetPerson }}</el-descriptions-item>
                    <el-descriptions-item label="量差管控类型：">{{ formData.nodeName }}</el-descriptions-item>
                    <el-descriptions-item label="管控节点设置：">{{ formData.initialTime }}</el-descriptions-item>
                    <el-descriptions-item label="节点参数：">{{ formData.nodeParam }}</el-descriptions-item>
                    <el-descriptions-item label="管控时间：">{{ formData.nodeControlTime }}</el-descriptions-item>

                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont"
                        :span="formData.whetherReleaseControl == 0 ? 1 : 2">
                        <el-select v-model="formData.whetherReleaseControl" style="width: 150px" clearable>
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item v-if="formData.whetherReleaseControl == 0" label="申请解控时间："
                        labelClassName="redFont">
                        <el-date-picker v-model="formData.releaseControlTime" style="width: 150px;" type="date"
                            unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="未及时处理原因说明：" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="formData.remark" placeholder="请输入" type="textarea"
                            style="width: 430px;">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="isLook" :files="files" @deleteFile="deleteFile"
                            @uplodeSuccess="uplodeSuccess" />
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px;margin-top: 24px;">历史申请流程</span>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark
        " :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="createTime" width="160"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="createUserName" width="70"></el-table-column>
                    <el-table-column label="量差管控类型" align="center" prop="nodeName"
                        width="auto"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="nodeControlTime" width="100"></el-table-column>
                    <el-table-column label="是否完全解控" align="center" prop="whetherReleaseControl" width="90"></el-table-column>
                    <el-table-column label="申请解控时间" align="center" prop="releaseControlTime" width="160"></el-table-column>
                    <el-table-column label="流程完成时间" align="center" prop="updateTime" width="160"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approvalStatus == 0">待确认</span>
                            <span v-if="scope.row.approvalStatus == 1">已确认</span>
                            <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                            <span v-if="scope.row.approvalStatus == 3">审批中</span>
                            <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                            <span v-if="scope.row.approvalStatus == 5">撤销</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="removeControlDig = false">关 闭</el-button>
                    <el-button class="bottom_all" @click="saveRemoveControl">提 交</el-button>
                </span>
            </el-dialog>
            <!-- 历史记录明细 -->
            <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false" >
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item label="工程名称：" :span="2">{{ historyDetailForm.engineeringName }}</el-descriptions-item>
                    <el-descriptions-item label="工程ID：">{{ historyDetailForm.engineeringId }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{ historyDetailForm.businesName }}</el-descriptions-item>
                    <el-descriptions-item label="施工进度：">{{ historyDetailForm.constructionProgress }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="签订主体：">{{ historyDetailForm.collaborationUnitName }}</el-descriptions-item>
                    <el-descriptions-item label="预算员：">{{ historyDetailForm.budgetPerson }}</el-descriptions-item>
                    <el-descriptions-item label="量差管控类型：">{{ historyDetailForm.nodeName }}</el-descriptions-item>
                    <el-descriptions-item label="管控节点设置：">{{ historyDetailForm.initialTime }}</el-descriptions-item>
                    <el-descriptions-item label="节点参数：">{{ historyDetailForm.nodeParam }}</el-descriptions-item>
                    <el-descriptions-item label="管控时间：">{{ historyDetailForm.nodeControlTime }}</el-descriptions-item>

                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont"
                        :span="historyDetailForm.whetherReleaseControl == 0 ? 1 : 2">
                        <el-select v-model="historyDetailForm.whetherReleaseControl" :disabled="true" style="width: 150px" clearable>
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item v-if="historyDetailForm.whetherReleaseControl == 0" label="申请解控时间："
                        labelClassName="redFont">
                        <el-date-picker v-model="historyDetailForm.releaseControlTime" :disabled="true" style="width: 150px;" type="date"
                            unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="未及时处理原因说明：" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="historyDetailForm.remark" :disabled="true" placeholder="请输入" type="textarea"
                            style="width: 430px;">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files2"  />
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px">领导审批参数</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont">{{
                        historyDetailForm.newWhetherReleaseControl == 1 ? "是" : "否" }}
                    </el-descriptions-item>
                    <el-descriptions-item v-if="historyDetailForm.newWhetherReleaseControl == 0"  label="申请解控时间：" labelClassName="redFont">
                        {{ historyDetailForm.newReleaseControlTime }}
                    </el-descriptions-item>
                </el-descriptions>
                <FlowsNodeList :tableData="approveTableData" />
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="提示" :visible="confirmDig" width="730px">
                <div><span style="color:red;font-size: 18px;margin-left: 12px;">请确认是否确认已完成【量差管控类型参数】？</span></div>
                <el-form ref="form" label-width="100px" class="form">
                    <el-form-item label="证明文件：">
                        <FileComponent fileCode="settlementFile" :disabled="isLook" :files="confirmFiles"
                            @deleteFile="deleteConfirmFile" @uplodeSuccess="uplodeSuccessConfirm" />
                    </el-form-item>
                    <el-form-item>
                        <span slot="label" style="color: #ff0000">备注：</span>
                        <el-input v-model="confirmForm.remark" style="width: 570px" placeholder="请填写备注" class="textarea"
                            type="textarea" resize="none" rows="3"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="confirmDig = false">取 消</el-button>
                    <el-button class="bottom_all" type="primary" @click="saveConfirm">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 历史记录 -->
            <el-dialog title="历史记录" :visible.sync="historyDig" width="1140px" :close-on-click-modal="false">
                <div class="tabtop" style="width: 380px">
                    <div v-for="(item, index) in dataTypeList" :key="index" @click="choose(item.status)">
                        <div :class="dataType == item.status ? 'active' : 'text'">
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <el-table v-if="dataType == 1" :header-cell-style="{ background: '#f3f6f9' }"
                    :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%;margin-top: 12px;"
                    tooltip-effect="dark" :data="confirmTableData">
                    <el-table-column label="量差管控类型" align="center" prop="nodeName" width="160"></el-table-column>
                    <el-table-column label="管控节点设置" align="center" prop="initialTime" width="120"></el-table-column>
                    <el-table-column label="节点参数" align="center" prop="nodeParam" width="120"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="nodeControlTime" width="120"></el-table-column>
                    <el-table-column label="确认状态" align="center" prop="confirmStatus" width="120"></el-table-column>
                    <el-table-column label="备注" align="center" prop="remark" width="120"></el-table-column>
                    <el-table-column label="确认时间" align="center" prop="creareTime" width="auto"></el-table-column>
                    <el-table-column label="确认人" align="center" prop="createUserName" width="120"></el-table-column>
                    <el-table-column label="附件" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookFile(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="dataType == 2" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark
        " :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="createTime" width="160"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="createUserName" width="70"></el-table-column>
                    <el-table-column label="量差管控类型" align="center" prop="nodeName"
                        width="auto"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="nodeControlTime" width="100"></el-table-column>
                    <el-table-column label="是否完全解控" align="center" prop="whetherReleaseControl" width="90"></el-table-column>
                    <el-table-column label="申请解控时间" align="center" prop="releaseControlTime" width="160"></el-table-column>
                    <el-table-column label="流程完成时间" align="center" prop="updateTime" width="160"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approvalStatus == 0">待确认</span>
                            <span v-if="scope.row.approvalStatus == 1">已确认</span>
                            <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                            <span v-if="scope.row.approvalStatus == 3">审批中</span>
                            <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                            <span v-if="scope.row.approvalStatus == 5">撤销</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDig = false">关 闭</el-button>
                </span>
            </el-dialog>
            <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { processDifferQuery, confirmNode, queryProcessDifferHistory, processDifferenceDownload as Download } from "@/api/internetSales/supplyManagement.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
import { getNodeList } from '@/api/task/flows';
import { getUserInfo } from "@/utils/auth.js";
import LookFile from "@/components/File/LookFile";
export default {
    components: {
        FileComponent,
        FlowsNodeList,
        LookFile
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "工程ID", prop: "engineeringId", status: true, width: "240", fixed: "left", },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left", },
                { label: "合同单位", prop: "businesName", status: true, width: "220" },
                { label: "签订主体", prop: "collaborationUnitName", status: true, width: "220" },
                // { label: "协调主体", prop: "coordinationSubject", status: true, width: "150" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "交底类型", prop: "discloseType", status: true, width: "auto" },
                { label: "结算方式", prop: "settleMethod", status: true, width: "auto" },
                { label: "责任预算", prop: "budgetPerson", status: true, width: "auto" },
                { label: "量差管控类型", prop: "nodeName", status: true, width: "180" },
                { label: "管控节点设置", prop: "initialTime", status: true, width: "100" },
                { label: "节点日期参数", prop: "nodeParam", status: true, width: "100" },
                { label: "管控时间", prop: "nodeControlTime", status: true, width: "100" },
                { label: "状态", prop: "nodeControlStatus", status: true, width: "auto" },
                { label: "审批/确定状态", prop: "approvalStatus", status: true, width: "auto" },
                { label: "审批/确定时间", prop: "approvalTime", status: true, width: "150" },
                { label: "操作", prop: "", status: true, width: "auto" },
            ],
            // queryPage: queryPage,
            DownloadURL: Download,
            tableData: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                engineeringName: "",
                budgetPerson: "",
                nodeControlStatus: "",
            },
            formData: {
                quantityDifferenceId: '',
                engineeringId: '',
                engineeringName: '',
                businesName: '',
                collaborationUnitName: '',
                coordinationSubject: '',
                budgetPerson: '',
                settleMethod: '',
                constructionProgress: '',
                discloseType: '',
                nodelType: '',
                nodeName: '',
                initialTime: '',
                nodeParam: '',
                nodeControlTime: '',
                whetherReleaseControl: '',
                releaseControlTime: '',
                attachment: '',
                remark: '',
                newReleaseControlTime:"",
                newWhetherReleaseControl:"",
            },
            historyDetailForm: {},
            files: [],
            files2: [],
            files3: [],
            files4: [],
            confirmFiles: [],
            isLook: false,
            removeControlDig: false,
            historyDetailDig: false,
            low: {},
            approveTableData: [],
            userRealName: "",
            confirmDig: false,
            confirmForm: {
                quantityDifferenceId: "",
                attachment: "",
                remark: ""
            },
            confirmTableData: [],
            removeControlTableData: [],
            historyDig: false,
            dataType: 1,
            dataTypeList: [
                {
                    value: "确认列表",
                    status: 1,
                },
                {
                    value: "解控列表",
                    status: 2,
                },
            ],
            lookFileVisible: false,
            lookFileConfig: { filePaths: "" },
        };
    },
    watch: {
    },
    async created() {
        this.tableParam.budgetPerson = await getUserInfo().userRealName;
        this.gettableData(true);
    },
    methods: {
        lookFile(row) {
            this.lookFileConfig.filePaths = row.attachment
            this.lookFileVisible = true
        },
        confirm(row) {
            this.low = JSON.parse(JSON.stringify(row))
            this.confirmForm = this.$options.data().confirmForm
            this.confirmForm.quantityDifferenceId = this.low.id
            this.confirmDig = true;

        },
        saveConfirm() {
            if (!this.confirmForm.remark) {
                this.$message.warning('备注不能为空!')
                return
            }
            if (this.confirmFiles.length > 0) {
                this.confirmForm.attachment = JSON.stringify(this.confirmFiles)
            } else {
                this.confirmForm.attachment = ""
            }
            confirmNode(this.confirmForm).then(res => {
                if (res.code == 1001) {
                    this.$message.success('保存成功!')
                    this.gettableData()
                    this.confirmDig = false;
                }
            })
        },
        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approvalStatus: item.approvalStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;

                }
            });
            this.historyDetailDig = true
        },
        saveRemoveControl() {
            console.log(this.formData)
            this.formData.newWhetherReleaseControl = this.formData.whetherReleaseControl
            this.formData.newReleaseControlTime = this.formData.releaseControlTime
            this.$router.push({
                name: "processDifferControlApproval",
                query: {
                    formData: JSON.stringify(this.formData),
                    dataContent: JSON.stringify(this.formData),
                    type: 1,
                }
            })
        },
        uplodeSuccess(data) {
            const params = {
                fileName: data.fileName,
                filePath: data.fileUrl,
            };
            this.files.push(params);
            this.formData.attachment = JSON.stringify(this.files);
        },
        deleteFile(index) {
            this.files.splice(index, 1);
            this.formData.attachment = JSON.stringify(this.files);
        },
        uplodeSuccessConfirm(data) {
            const params = {
                fileName: data.fileName,
                filePath: data.fileUrl,
            };
            this.confirmFiles.push(params);
        },
        deleteConfirmFile(index) {
            this.confirmFiles.splice(index, 1);
        },
        gettableData() {
            processDifferQuery(this.tableParam).then(res => {
                if (res.code == 1001) {
                    this.total = res.data.totalRows
                    this.tableData = res.data.data
                    //第一次进入页面获取最近一个月的数据 回显筛选
                    if (!this.tableParam.dataMouth) {
                        this.tableParam.dataMouth = res.data.data[0].dataMouth
                    }
                }
            })
        },
        //type 为1 只展示历史
        applyRemoveControl(row) {
            if (row.nodeControlStatus == 3) {
                this.$message.warning('不需要重复解控!')
                return
            }
            queryProcessDifferHistory({ engineeringId: row.engineeringId }).then(res => {
                if (res.code == 1001) {
                    this.formData = this.$options.data().formData
                    this.low = JSON.parse(JSON.stringify(row))
                    this.formData = {
                        ...this.formData, ...Object.fromEntries(
                            Object.keys(this.formData).map(key => [key, this.low[key]])
                        )
                    }
                    this.formData.quantityDifferenceId = this.low.id
                    this.removeControlTableData = res.data.historyList
                    this.removeControlDig = true
                }
            })


        },
        getProcessDifferHistory(row) {
            queryProcessDifferHistory({ engineeringId: row.engineeringId }).then(res => {
                if (res.code == 1001) {
                    this.formData = JSON.parse(JSON.stringify(row))
                    this.low = JSON.parse(JSON.stringify(row))
                    this.confirmTableData = res.data.records
                    this.removeControlTableData = res.data.historyList
                    this.historyDig = true
                }
            })
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
        choose(num) {
            this.dataType = num;
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}
</style>
  